import React from 'react';
import '../template-file-css/document-file-template.css';


export const LCS_CrisisSafetyPlan = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='LCS_CrisisSafetyPlan' className='file-pdf-document'>
            <div className='file-template'>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Step 1: Warning signs (thoughts, images, mood,
                                situation, behavior) that a crisis may be developing:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_1" name="cb_1" className='add-only' value="1" /> Changes in sleep
                            habits
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_2" name="cb_2" className='add-only' value="1" /> Relapsing in
                            addictive behavior
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_3" name="cb_3" className='add-only' value="1" /> Changes in eating
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_4" name="cb_4" className='add-only' value="1" /> Feel depressed
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_5" name="cb_5" className='add-only' value="1" /> Seeing figures
                            and/or hearing voices
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_6" name="cb_6" className='add-only' value="1" /> Experience panic
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_7" name="cb_7" className='add-only' value="1" /> Negative thoughts
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_8" name="cb_8" className='add-only' value="1" /> Racing thoughts
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_9" name="cb_9" className='add-only' value="1" /> Worried and anxious
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_10" name="cb_10" className='add-only' value="1" /> Angry and
                            irritable
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_11" name="cb_11" className='add-only' value="1" /> Feelings of
                            self-harm
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_12" name="cb_12" className='add-only' value="1" /> Conflicts with
                            others
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_13" name="cb_13" className='add-only' value="1" /> Feelings of
                            harming others
                        </td>
                        <td className='w-375'>&nbsp; </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Step 2: Coping strategies/Actions- Things I can do take
                                my mind off my problems:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_14" name="cb_14" className='add-only' value="1" /> Read
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_15" name="cb_15" className='add-only' value="1" /> Take a walk
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_16" name="cb_16" className='add-only' value="1" /> Relaxation
                            Techniques
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_17" name="cb_17" className='add-only' value="1" /> Safely release my
                            anger or frustration
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_18" name="cb_18" className='add-only' value="1" /> Rest
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_19" name="cb_19" className='add-only' value="1" /> Take time to be
                            by myself
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_181" name="cb_181" className='add-only' value="1" /> Talk with friends
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_191" name="cb_191" className='add-only' value="1" /> Call somebody who
                            understands
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_20" name="cb_20" className='add-only' value="1" /> Watch TV
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_21" name="cb_21" className='add-only' value="1" /> Social settings
                            such as movies,store,restaurant,etc
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_22" name="cb_22" className='add-only' value="1" /> Listen To Music
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_23" name="cb_23" className='add-only' value="1" /> Exercise
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Step 3: People I can ask for help/support system
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>&nbsp; </td>
                        <td className='w-250'> <strong>Name</strong> </td>
                        <td className='w-250'> <strong>Phone Number</strong> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <strong>Family Member</strong>
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txt_24" name="txt_24" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txt_25" name="txt_25" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <strong>Friend</strong>
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txt_26" name="txt_26" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txt_27" name="txt_27" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <strong>Other</strong>
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txt_28" name="txt_28" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txt_29" name="txt_29" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <strong>Other</strong>
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txt_30" name="txt_30" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txt_31" name="txt_31" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Step 4: Actions to be taken/Making the environment safe:</span>
                    <input type="checkbox" id="cb_24" name="cb_24" className='add-only' value="1" /> Respond to periods of increased emotional pain &nbsp;
                    <input type="checkbox" id="cb_25" name="cb_25" className='add-only' value="1" /> Restrict access to lethal means &nbsp;
                    <input type="checkbox" id="cb_26" name="cb_26" className='add-only' value="1" /> Increase monitoring
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Name, title, and contact information for the primary
                                CPST/PSR Worker and other agency support staff including the </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <strong>Therapist</strong>
                            <input type="text" id="txt_32" name="txt_32" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <strong>LMHP</strong>
                            <input type="text" id="txt_33" name="txt_33" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'> 
                <h4>Communication Plan</h4>
                </p>
                <p className='w-750'> 
                <ol>
                    <li>Therapist will contact the family at least 1 time per week.</li>
                    <li>Family will contact the therapsist at (318)213-0904-Shreveport-Alexandia,(337)205-6073-
                        Lafayette, as needed to report any major changes in mood or behaviors.</li>
                    <li>Support System will be contacted to assist when necessary.</li>
                </ol>
                </p>
                <p className='w-750'>
                    Plan will run for 90 days and will be reviewed/ revised by the family, identified supports,
                    Therapist, and Licensed supervisor.
                    <br />
                    Client will report to nearest ER if he/she becomes a danger to self or others, or client will
                    call 911.

                </p>
                <table>
                    <tr>
                        <td className='signature w-750'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-750'>Signature</td>
                    </tr>
                </table> 
            </div>
        </form>

    )
} 